module.exports = __webpack_public_path__ + "static/media/debt-person.6acfa2e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/debt-person.svg
// module id = 194
// module chunks = 0